import React from 'react';

import { ToolboxErrorMessage } from 'craft/components/ToolboxErrorMessage';
import { useValidationError } from 'craft/hooks/useValidationError';

const ValidationErrorMessages = ({ nodeIds }: { nodeIds?: string[] }) => {
  const validationError = useValidationError(nodeIds);
  if (!validationError) {
    return null;
  }

  return <ToolboxErrorMessage message={validationError.message} />;
};

export default ValidationErrorMessages;
